import { render, staticRenderFns } from "./Dropdown.vue?vue&type=template&id=5459e7f0&scoped=true&"
import script from "./Dropdown.vue?vue&type=script&lang=js&"
export * from "./Dropdown.vue?vue&type=script&lang=js&"
import style0 from "./Dropdown.vue?vue&type=style&index=0&id=5459e7f0&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5459e7f0",
  null
  
)

export default component.exports